module.exports = __webpack_public_path__ + "img/BenuaHaulageROT.94bc7603.png";